import type { ReactNode } from "react";
import { MapPin, Star, Store } from "lucide-react";
import type { SlideProps } from "@/engine/types";
import { chapterMeta } from "@/engine/chapters";
import { RevealItem, RevealList, SlideShell } from "@/ui";
import { TopicCard } from "./components/TopicCard";
import type { Topic } from "./components/TopicCard";

const [FROM, TO] = chapterMeta(4).accent;

/** Semibold-white emphasis (source deck's **bold**). */
function B({ children }: { children: ReactNode }) {
  return <span className="font-semibold text-white">{children}</span>;
}

const TOPICS: readonly Topic[] = [
  {
    icon: MapPin,
    color: FROM,
    title: "Google Business Profile",
    lines: [
      <>
        Accurate <B>name, address, hours</B>, categories, and photos
      </>,
      <>
        Match your site's <B>NAP</B> — name, address, phone — wherever you show it
      </>,
    ],
  },
  {
    icon: Store,
    color: TO,
    title: "Local landing pages",
    lines: [
      <>For the areas you actually serve</>,
      <>
        With <B>real local content</B> on every page
      </>,
    ],
    // warn: <>Not doorways with swapped city names only.</>,
  },
  {
    icon: Star,
    color: "#fbbf24",
    title: "Reviews",
    lines: [
      <>
        Earn them <B>ethically</B>
      </>,
      <>
        <B>Respond</B> — show active management
      </>,
    ],
    // warn: <>Never buy fake reviews.</>,
  },
];

export function LocalSeoSlide({ active }: SlideProps) {
  return (
    <SlideShell chapter={4} title="Local SEO">
      <RevealList
        active={active}
        stagger={0.16}
        className="mx-auto grid w-full max-w-6xl grid-cols-3 gap-8"
      >
        {TOPICS.map((topic) => (
          <RevealItem key={topic.title} className="h-full">
            <TopicCard topic={topic} />
          </RevealItem>
        ))}
      </RevealList>
    </SlideShell>
  );
}
